import { useOktaAuth } from '@okta/okta-react';
import React from "react";
import { TagsApi } from "../ApiHelper";


export const useTags = (): TagsApi => {
  const { authState } = useOktaAuth();
  const [tags, setTags] = React.useState(new TagsApi(authState?.accessToken?.accessToken));
  return tags;
}